import React from "react";
import { Page } from "../../activities/AppPage";
import CareMomentsIntroScreen from "./CareMomentsIntroScreen";

type Props = {
  onRequestNavigate: (page: Page) => void;
  onClickGoBack: () => void;
};

export default function CareMomentsIntroActivity(props: Props) {
  return (
    <CareMomentsIntroScreen
      onRequestNavigate={props.onRequestNavigate}
      onClickGoBack={props.onClickGoBack}
    />
  );
}
